import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import { CommsService } from '../../services/comms/comms.service';
import { DisplayService } from '../../services/display/display.service';

@Component({
	selector: 'pcm-privacy-notice',
	templateUrl: './privacy-notice.component.html',
	styleUrls: ['./privacy-notice.component.scss']
})
export class PrivacyNoticeComponent implements OnInit {

	errorMsg = '';
	constructor(
		private location: Location,
		private router: Router,
		private commsService: CommsService,
		public userService: UserService,
		public displayService: DisplayService) { }

	ngOnInit() { }

	agreeNotice() {
		this.displayService.startLoading();
		const self = this;
		this.commsService.sendPrivacyAgreement().subscribe((res) => {
			try {
				self.userService.setAuth();
				self.userService.displayPrivacyNotice = false;
			} catch (err) {
				self.errorMsg = 'Send Privacy Agreement ERROR: ' + err;
				console.log('Send Privacy Agreement ERROR: ' + err);
				if (err && err.error && err.error.message) {
						self.errorMsg = err.error.message;
				}
			} finally {
				this.displayService.endLoading();
			}
		}, (err) => {
			self.errorMsg = 'Send Privacy Agreement ERROR: ' + err;
			console.log('Send Privacy Agreement ERROR: ' + err);
			if (err && err.error && err.error.message) {
				self.errorMsg = err.error.message;
			}
			this.displayService.endLoading();
		});
	}

	disagreeNotice() {
		this.userService.displayPrivacyNotice = false;
		this.router.navigateByUrl('logout');
	}

	closeNotice() {
		if (this.errorMsg !== '') {
			this.userService.displayPrivacyNotice = false;
			this.router.navigateByUrl('logout');
		} else {
			this.location.back();
		}
	}
}
